import MathJax from 'react-mathjax';
import NoteBox from './NoteBox';
import './Equation.css';

const Equation = (props) => {

  return(
    <NoteBox equation={true}>
      <MathJax.Provider>
      <MathJax.Node formula={props.tex} />
      </MathJax.Provider>
    </NoteBox>
  )
}

export default Equation;